export const SET_COLORS = 'SET_COLORS';
export const SET_THEME_COLOR = 'SET_THEME_COLOR';
export const SET_ICON_COLOR = 'SET_ICON_COLOR';
export const SET_EMAIL_COLOR = 'SET_EMAIL_COLOR';
export const SET_SLIDESHOW_COLOR = 'SET_SLIDESHOW_COLOR';
